module.exports = __webpack_public_path__ + "public/adminIcons/manageListing.svg?0898f2b5";